import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { showModal } from '../actions/modalActions';
import { MODAL_TYPE_NOTIFICATION } from '../constants/modalTypes';

import PrivacyPolicy from './legal/privacyPolicy';
import TermsOfUse from './legal/termsOfUse';
import ContactUs from './legal/contactUs';
import { PhoneNumber } from './common/phoneNumber';

import config from '../config';
import './footer.css';

import { Col, Row } from 'reactstrap';
import { useAppDispatch } from '../store';

type FooterProps = {
    instance: {
        supportPhoneOverride?: String;
        supportEmailOverride?: String;
        showSupportEmail?: boolean;
        showSupportPhone?: boolean;
    }
}
function Footer({ instance }: FooterProps) {

    const [year] = useState(new Date().getFullYear());
    const dispatch = useAppDispatch();

    const showTermsOfUse = (event: any) => {
        event.preventDefault();
       dispatch(showModal(MODAL_TYPE_NOTIFICATION, {
            title: 'Terms of Use',
            children: <TermsOfUse />,
            contentClassName: 'scrollable',
            size: 'lg',
       }));
    };

    const showContactUs = (event: any) => {
        event.preventDefault();
        dispatch(showModal(MODAL_TYPE_NOTIFICATION, {
            title: 'Contact Us',
            children: <ContactUs />,
        }));
    };

    const phone = instance.supportPhoneOverride ? (
        <PhoneNumber value={instance.supportPhoneOverride} />
    ) : (
        <PhoneNumber value={'(629) 777-5552'} />
    );

	return (
		<Row className="footer2">
			<Col>
				<span>
					&copy; {year} <a href="http://www.myhealthdirect.com">MyHealthDirect</a>
				</span>
				<span className="footerDivider2"> | </span>
				<PrivacyPolicy />
				<span className="footerDivider2"> | </span>
				<Link to="/terms-of-use" onClick={showTermsOfUse}>
					Terms of Use
				</Link>
			</Col>
			<Col className="text-end">
				{(instance.showSupportEmail && instance.supportEmailOverride) && (
					<span>
						<a href={`mailto:${instance.supportEmailOverride}`}>Email Support</a>
						<span className="footerDivider2"> | </span>
					</span>
				)}
				{instance.showSupportPhone && (
					<span>
						<span>
							<span style={{ marginRight: '5px' }}>
								<FontAwesomeIcon icon="phone" flip="horizontal" />
							</span>
							{phone}
						</span>
						<span className="footerDivider2"> | </span>
					</span>
				)}
				<span>{config.version}</span>
			</Col>
		</Row>

		// <div className="navbar-dark navbar footer row">
		// 	<div className="col">
		// 		<span>� {this.state.year} <a href="http://www.myhealthdirect.com">MyHealthDirect</a></span>
		// 		<span className="footerDivider"> | </span>
		// 		<Link to="/privacy-policy" onClick={this.showPrivacyPolicy}>Privacy Policy</Link>
		// 		<span className="footerDivider"> | </span>
		// 		<Link to="/terms-of-use" onClick={this.showTermsOfUse}>Terms of Use</Link>
		// 	</div>
		// 	<div className="col text-right">
		// 		<a href="mailto:support@myhealthdirect.com">Email MHD's Support</a>
		// 		<span className="footerDivider"> | </span>
		// 		<span><span style={{marginRight:"5px"}}><FontAwesomeIcon icon="phone" flip="horizontal" /></span>(629) 777-5552</span>
		// 		<span className="footerDivider"> | </span>
		// 		<span>{config.version}</span>
		// 	</div>
		// </div>
	);
}

export default Footer;